import React, { Component } from "react";

import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import FormsyComposedTextField from "./FormsyComposedTextField";

class FormsyComposedPasswordField extends Component {
  state = { showPassword: false };

  toggleShowPassword = () => {
    this.setState(prev => ({ showPassword: !prev.showPassword }));
  };

  render() {
    const { showPassword } = this.state;

    return (
      <FormsyComposedTextField
        {...this.props}
        type={showPassword ? "text" : "password"}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              onClick={this.toggleShowPassword}
              edge="end"
              size="small"
              tabindex="-1"
            >
              <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"} />
            </IconButton>
          </InputAdornment>
        }
      />
    );
  }
}

export default FormsyComposedPasswordField;
